import { UserMultipleIcon } from "@hugeicons/core-free-icons";
import { Icon } from "@codel/dova-ds";

/** The 2-person glyph for in person, the same mark as portal-www's `InPersonIcon`. Video keeps the
 *  DS camera. The DS `Icon` forwards no aria props, so the wrapper carries `aria-hidden`. */
export function InPersonIcon({ size = 16 }: { size?: number }) {
  return (
    <span aria-hidden="true" className="inline-flex shrink-0">
      <Icon icon={UserMultipleIcon} size={size} />
    </span>
  );
}
